import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-tooltip-mobile',
  templateUrl: './tooltip-mobile.component.html',
  styleUrls: ['./tooltip-mobile.component.scss'],
  standalone: false
})
export class TooltipMobileComponent {
  id?: string;

  titre: string;

  texte: string;

  constructor(
    public dialogRef: MatDialogRef<TooltipMobileComponent>,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {
    this.id = data.id;
    this.titre = data.titre;
    this.texte = data.texte;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
